import { useSelector } from 'react-redux';

import { contextToPageNameMap } from 'constants/context';
import commonStrings from 'modules/common/strings';
import logo from 'assets/images/logo.svg';
import SectionDivider from 'modules/common/components/SectionDivider';

import {
  Wrapper,
  LogoWrapper,
  Logo,
  ItemContainer,
  ItemLink,
  ItemWrapper,
  Item,
} from './Sidebar.style';
// ###############################################################
// <------------------------ Constants -------------------------->
// ###############################################################
// ###############################################################
// <---------------------- End Constants ------------------------>
// ###############################################################
const Sidebar = () => {
  // ###############################################################
  // <------------------------ useState --------------------------->
  // ###############################################################
  // ###############################################################
  // <---------------------- End useState ------------------------->
  // ###############################################################
  // ###############################################################
  // <------------------------ useEffect -------------------------->
  // ###############################################################
  // ###############################################################
  // <---------------------- End useEffect ------------------------>
  // ###############################################################
  // ###############################################################
  // <--------------------- rest of hooks ------------------------->
  // ###############################################################
  // ###############################################################
  // <-------------------- End rest of hooks ---------------------->
  // ###############################################################
  // ###############################################################
  // <------------------------- Globals --------------------------->
  // ###############################################################
  const context = useSelector(state => state.common.context);

  const sidebarItems = [
    {
      contexts: ['profile'],
      name: contextToPageNameMap.profile,
      icon: '"\\e902"',
    },
    {
      contexts: ['posts', 'addPost'],
      name: contextToPageNameMap.posts,
      icon: '"\\e901"',
    },
    {
      contexts: ['rssFeed', 'addRssFeed'],
      name: contextToPageNameMap.rssFeed,
      icon: '"\\ea15"',
    },
    {
      contexts: ['doctors'],
      name: contextToPageNameMap.doctors,
      icon: '"\\e972"',
    },
    {
      contexts: ['companyActivation'],
      name: contextToPageNameMap.companyActivation,
      icon: '"\\e90d"',
    },
    {
      contexts: ['closedCircles'],
      name: contextToPageNameMap.closedCircles,
      icon: '"\\e92f"',
    },
    {
      contexts: ['companies', 'addCompany'],
      name: contextToPageNameMap.companies,
      icon: '"\\e903"',
    },
  ];
  // ###############################################################
  // <----------------------- End Globals ------------------------->
  // ###############################################################
  // ###############################################################
  // <-------------------------- Logic ---------------------------->
  // ###############################################################
  // ###############################################################
  // <------------------------ End Logic -------------------------->
  // ###############################################################
  // ###############################################################
  // <------------------------- Actions --------------------------->
  // ###############################################################
  // ###############################################################
  // <----------------------- End Actions ------------------------->
  // ###############################################################
  // ###############################################################
  // <----------------------- UI Handlers ------------------------->
  // ###############################################################
  // ###############################################################
  // <--------------------- End UI Handlers ----------------------->
  // ###############################################################
  // ###############################################################
  // <-------------------------- Render --------------------------->
  // ###############################################################
  // ###############################################################
  // <------------------------ End Render ------------------------->
  // ###############################################################
  // ###############################################################
  // <------------------------- Return UI ------------------------->
  // ###############################################################
  return (
    <Wrapper>
      <LogoWrapper>
        <Logo src={logo} alt={commonStrings.sidebar.logoImageAltText} />
      </LogoWrapper>
      {sidebarItems.map(sidebarItem => {
        const isItemSelected = sidebarItem.contexts.includes(context);
        return (
          <ItemContainer key={sidebarItem.contexts[0]} pushToEnd={sidebarItem.pushToEnd}>
            <ItemLink to={`/${sidebarItem.contexts[0]}`}>
              <ItemWrapper icon={sidebarItem.icon} selected={isItemSelected}>
                {sidebarItem.name && (
                  <>
                    <SectionDivider gap={6} />
                    <Item>{sidebarItem.name}</Item>
                  </>
                )}
              </ItemWrapper>
            </ItemLink>
          </ItemContainer>
        );
      })}
    </Wrapper>
  );
  // ###############################################################
  // <----------------------- End Return UI ----------------------->
  // ###############################################################
};

Sidebar.propTypes = {};

Sidebar.defaultProps = {};

export default Sidebar;
